import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};
// جلب شرائح/تصنيفات الشحن (مجموعة حسب الدولة)
export const getShippingCategories = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/get-shipping-categories`, {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping categories:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// ✅ جلب شريحة شحن واحدة بالـ id
export const getShippingCategoryById = async (categoryId, params = {}) => {
  if (!categoryId) throw new Error("categoryId is required.");

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/get-shipping-category/${categoryId}`,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching shipping category by id:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// إنشاء Shipping Categories (bulk)
export const createShippingCategories = async (categories, params = {}) => {
  if (!Array.isArray(categories) || !categories.length) {
    throw new Error("categories is required and must be a non-empty array.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/create-shipping-category`,
      { categories },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating shipping categories:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// تحديث شريحة/تصنيف شحن
export const updateShippingCategory = async (categoryId, data, params = {}) => {
  /**
   * data = {
   *   name?: string,
   *   cost?: string | number,
   *   country_id?: string | number
   * }
   */

  if (!categoryId) {
    throw new Error("categoryId is required to update shipping category.");
  }

  if (!data || typeof data !== "object") {
    throw new Error("data is required to update shipping category.");
  }

  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      formData.append(key, value);
    }
  });

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-shipping-category/${categoryId}`,
      formData,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating shipping category:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
export const deleteShippingCategory = async (categoryId, params = {}) => {
  if (!categoryId) {
    throw new Error("categoryId is required to delete shipping category.");
  }

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/delete-shipping-category/${categoryId}`,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting shipping category:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// جلب المدن
export const getCities = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params, // لو حبيت تضيف فلترة مستقبلاً
  };

  try {
    const response = await api.get(
      "/admin/get-city",
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching cities:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// إنشاء مدن جديدة (Bulk)
export const createCities = async (cities, params = {}) => {
  /**
   * cities: Array of
   * {
   *   name_ar: string,
   *   name_en: string,
   *   status: boolean | number,
   *   shipping_category_id: number | null,
   *   governorate_id: number
   * }
   */

  if (!Array.isArray(cities) || cities.length === 0) {
    throw new Error("cities array is required to create cities.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      "/admin/create-cities",
      { cities },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error creating cities:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// تحديث مدينة
export const updateCity = async (cityId, data, params = {}) => {
  /**
   * cityId: number
   * data = {
   *   name_ar?: string,
   *   name_en?: string,
   *   status?: boolean | number,
   *   shipping_category_id?: number | null
   * }
   */

  if (!cityId) {
    throw new Error("cityId is required to update city.");
  }

  if (!data || typeof data !== "object") {
    throw new Error("data is required to update city.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-city/${cityId}`,
      data,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating city:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// حذف مدينة بواسطة id (GET)
export const deleteCity = async (cityId, params = {}) => {
  if (!cityId) throw new Error("cityId is required to delete city.");

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/delete-city/${cityId}`, {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting city:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// إنشاء محافظات (Bulk)
export const createGovernorates = async (governorates, params = {}) => {
  // لازم Array
  if (!Array.isArray(governorates) || governorates.length === 0) {
    throw new Error("governorates array is required to create governorates.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  // ✅ API expect: { governorates: [...] }
  const payload = { governorates };

  try {
    const response = await api.post(`/admin/create-goverorates`, payload, {
      headers,
      params: mergedParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating governorates:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// تحديث محافظة
export const updateGovernorate = async (governorateOrId, data, params = {}) => {
  const governorateId =
    typeof governorateOrId === "object" && governorateOrId !== null
      ? governorateOrId.id
      : governorateOrId;

  if (!governorateId) {
    throw new Error("governorateId is required to update governorate.");
  }

  if (!data || typeof data !== "object") {
    throw new Error("data is required to update governorate.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-goverorate/${governorateId}`,
      data,
      { headers, params: mergedParams }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating governorate:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// حذف محافظة
export const deleteGovernorate = async (governorateOrId, params = {}) => {
  const governorateId =
    typeof governorateOrId === "object" && governorateOrId !== null
      ? governorateOrId.id
      : governorateOrId;

  if (!governorateId) {
    throw new Error("governorateId is required to delete governorate.");
  }

  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(
      `/admin/delete-goverorate/${governorateId}`,
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting governorate:", error);

    const serverData = error?.response?.data;
    if (serverData?.message) {
      const err = new Error(serverData.message);
      err.original = error;
      throw err;
    }

    throw error;
  }
};
// جلب المحافظات
export const getGovernorates = async (params = {}) => {
  const headers = {
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/get-goverorates`, {
      headers,
      params: mergedParams,
    });

    // response.data = { success, message, data: { "": [...] } }
    return response.data;
  } catch (error) {
    console.error("Error fetching governorates:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
